import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import JobsScoutComp from './JobsScoutComp';

function JobsScout() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <JobsScoutComp />
      </div>
    </div>
  );
}

export default JobsScout;
